import { render } from "./FlowHistoryShow.vue?vue&type=template&id=775ba3ea"
import script from "./FlowHistoryShow.vue?vue&type=script&lang=js"
export * from "./FlowHistoryShow.vue?vue&type=script&lang=js"
script.render = render

export default script